import React from "react";

const FileIcon = ({ fill }) => {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none">
      <path
        d="M4 2.5V11.5C4 11.8978 4.15804 12.2794 4.43934 12.5607C4.72064 12.842 5.10218 13 5.5 13H11.5C11.8978 13 12.2794 12.842 12.5607 12.5607C12.842 12.2794 13 11.8978 13 11.5V4.9315C13 4.73167 12.96 4.53386 12.8825 4.34968C12.805 4.16551 12.6914 3.99868 12.5485 3.859L10.0623 1.4275C9.78202 1.15349 9.40568 1.00005 9.01375 1H5.5C5.10218 1 4.72064 1.15804 4.43934 1.43934C4.15804 1.72064 4 2.10218 4 2.5V2.5Z"
        stroke={fill}
        strokeWidth="1.50249"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13V14.5C10 14.8978 9.84196 15.2794 9.56066 15.5607C9.27936 15.842 8.89782 16 8.5 16H2.5C2.10218 16 1.72064 15.842 1.43934 15.5607C1.15804 15.2794 1 14.8978 1 14.5V6.25C1 5.85218 1.15804 5.47064 1.43934 5.18934C1.72064 4.90804 2.10218 4.75 2.5 4.75H4"
        stroke={fill}
        strokeWidth="1.50249"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

FileIcon.defaultProps = {
  width: 20,
  height: 19,
  fill: "white",
};

export default FileIcon;
